export default __webpack_public_path__ + "static/media/be-sure-step3.efecc2df.png";